/* tslint:disable */
/* eslint-disable */
/**
 * Business Orchestration Layer (BOL) API
 * Business Orchestration layer (BOL) API. Public part, exposed to BOL client applications.  Glossary | Definition -- | -- <strong>Logistics Object</strong> | A resource in the BOL system that represents a business entity, such as a QuotationRequest, Quotation, or Service. Logistics Objects are managed through the BOL API and can be accessed or modified by Users based on their permissions i.e. based on their AD Entra ID roles and ACL (Access Control List) modes. <strong>Member</strong> | A data owner in the BOL system, uniquely identified by its `memberIdentifier`. Members are used to manage access control and ownership of Logistics Objects. <strong>User</strong> | A person or entity that interacts with the BOL system, typically through a client application, and beeing authenticated. Users are associated with Members and can perform actions on Logistics Objects based on their access level. User access token includes the Member identifier as part of roles claims. Each path in the API is protected by a custom role defined in AD Entra ID, and operations on Logistics Objects are protected by specific Access modes defined by members. <strong>Access Control</strong> | The mechanism by which the BOL system restricts access to API paths and resources based on the identity of the User and their associated Member. Access control is enforced through AD Entra ID roles and ACL (Access Control List) modes defined for every single Logistics Object. <strong>ACL (Access Control List)</strong> | A set of authorizations that define what actions a User can perform on a Logistics Object. The level of access granted to Users is determined by ACL modes defined in authorizations for specific Logistics Objects. ACL Modes are not directly associated with Users but rather with Members, which are the data owners of Logistics Objects. Each Logistics Object has an ACL that specifies the access modes for different Members. Members need to exist in the BOL system to be granted access to Logistics Objects. <strong>ACL Mode</strong> | The specific level of access control applied to a Logistics Object, determining what actions can be performed by Users. ACL modes are defined for each Logistics Object by `memberIdentifier` and include `READ`, `WRITE`, and `CONTROL`. Each mode includes access granted by the modes under it, so `CONTROL` includes `WRITE` and `READ`, and `WRITE` includes `READ`. <strong>Change Request</strong> | A request to modify a Logistics Object, which is processed by the BOL system. Change requests are created when a User wants to update an existing Logistics Object, and they are subject to approval and application by the system. All changes to Logistics Objects are done through change requests. This allows for a controlled and auditable process of modifications. <strong>Host</strong> | A server alias in the BOL system, used to abstract URI values internally. This allows for flexibility in the underlying infrastructure when migrating or changing server configurations. 
 *
 * The version of the OpenAPI document: 7.2.1-develop.2
 * Contact: benoit.tiers@logist-x.eu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ACL,
  ACLAuthorization,
  ACLAuthorizationRequest,
  ChangeRequest,
  ChangeRequestCreateRequest,
  ChangeRequestPatchRequest,
  ErrorResponse,
  EventCreateRequest,
  LogisticsObjectMetadata,
  PaginatedChangeRequests,
  PaginatedEvents,
  SearchServicesRequest,
  SearchServicesResponse,
  Service,
  ServiceResponse,
} from '../models/index';
import {
    ACLFromJSON,
    ACLToJSON,
    ACLAuthorizationFromJSON,
    ACLAuthorizationToJSON,
    ACLAuthorizationRequestFromJSON,
    ACLAuthorizationRequestToJSON,
    ChangeRequestFromJSON,
    ChangeRequestToJSON,
    ChangeRequestCreateRequestFromJSON,
    ChangeRequestCreateRequestToJSON,
    ChangeRequestPatchRequestFromJSON,
    ChangeRequestPatchRequestToJSON,
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
    EventCreateRequestFromJSON,
    EventCreateRequestToJSON,
    LogisticsObjectMetadataFromJSON,
    LogisticsObjectMetadataToJSON,
    PaginatedChangeRequestsFromJSON,
    PaginatedChangeRequestsToJSON,
    PaginatedEventsFromJSON,
    PaginatedEventsToJSON,
    SearchServicesRequestFromJSON,
    SearchServicesRequestToJSON,
    SearchServicesResponseFromJSON,
    SearchServicesResponseToJSON,
    ServiceFromJSON,
    ServiceToJSON,
    ServiceResponseFromJSON,
    ServiceResponseToJSON,
} from '../models/index';

export interface CreateChangeRequestOnServiceByIdRequest {
    serviceId: string;
    contentType: CreateChangeRequestOnServiceByIdContentTypeEnum;
    changeRequestCreateRequest: ChangeRequestCreateRequest;
    source?: boolean;
    accept?: CreateChangeRequestOnServiceByIdAcceptEnum;
    traceparent?: string;
}

export interface CreateServiceRequest {
    contentType: CreateServiceContentTypeEnum;
    xBOLMemberIdentifier: string;
    service: Service;
    id?: string;
    source?: boolean;
    accept?: CreateServiceAcceptEnum;
    traceparent?: string;
    xBOLACLAuthorizations?: string;
}

export interface CreateServiceEventRequest {
    serviceId: string;
    contentType: CreateServiceEventContentTypeEnum;
    xBOLMemberIdentifier: string;
    eventCreateRequest: EventCreateRequest;
    accept?: CreateServiceEventAcceptEnum;
    traceparent?: string;
}

export interface DeleteServiceACLAuthorizationByMemberIdRequest {
    serviceId: string;
    memberId: string;
    xBOLMemberIdentifier: string;
    aclRevision?: string;
    traceparent?: string;
}

export interface DeleteServiceByIdRequest {
    serviceId: string;
    traceparent?: string;
}

export interface DeleteServiceEventByIdRequest {
    serviceId: string;
    eventId: string;
    xBOLMemberIdentifier: string;
    traceparent?: string;
}

export interface GetChangeRequestOnServiceByIdRequest {
    serviceId: string;
    changeRequestId: string;
    accept?: GetChangeRequestOnServiceByIdAcceptEnum;
    traceparent?: string;
}

export interface GetServiceACLAuthorizationByMemberIdRequest {
    serviceId: string;
    memberId: string;
    at?: string;
    aclRevision?: string;
    accept?: GetServiceACLAuthorizationByMemberIdAcceptEnum;
    traceparent?: string;
}

export interface GetServiceACLByIdRequest {
    serviceId: string;
    at?: string;
    revision?: string;
    accept?: GetServiceACLByIdAcceptEnum;
    traceparent?: string;
}

export interface GetServiceByIdRequest {
    serviceId: string;
    at?: string;
    revision?: string;
    accept?: GetServiceByIdAcceptEnum;
    traceparent?: string;
}

export interface GetServiceEventsRequest {
    serviceId: string;
    limit?: number;
    offset?: number;
    startAt?: Date;
    endAt?: Date;
    code?: string;
    type?: string;
    accept?: GetServiceEventsAcceptEnum;
    traceparent?: string;
}

export interface GetServiceMetadataByIdRequest {
    serviceId: string;
    accept?: GetServiceMetadataByIdAcceptEnum;
    traceparent?: string;
}

export interface ListChangeRequestsOfServiceByIdRequest {
    serviceId: string;
    limit?: number;
    offset?: number;
    accept?: ListChangeRequestsOfServiceByIdAcceptEnum;
    traceparent?: string;
}

export interface PatchServiceByIdRequest {
    serviceId: string;
    contentType: PatchServiceByIdContentTypeEnum;
    xBOLMemberIdentifier: string;
    service: Service;
    revision?: string;
    accept?: PatchServiceByIdAcceptEnum;
    traceparent?: string;
}

export interface SearchServiceGetRequest {
    id?: string;
    searchBody?: SearchServicesRequest;
    accept?: SearchServiceGetAcceptEnum;
    traceparent?: string;
}

export interface SearchServicesPostRequest {
    contentType: SearchServicesPostContentTypeEnum;
    searchServicesRequest: SearchServicesRequest;
    limit?: number;
    offset?: number;
    accept?: SearchServicesPostAcceptEnum;
    traceparent?: string;
}

export interface UpdateChangeRequestOnServiceByIdRequest {
    serviceId: string;
    changeRequestId: string;
    contentType: UpdateChangeRequestOnServiceByIdContentTypeEnum;
    changeRequestPatchRequest: ChangeRequestPatchRequest;
    accept?: UpdateChangeRequestOnServiceByIdAcceptEnum;
    traceparent?: string;
}

export interface UpdateServiceByIdRequest {
    serviceId: string;
    contentType: UpdateServiceByIdContentTypeEnum;
    xBOLMemberIdentifier: string;
    service: Service;
    revision?: string;
    accept?: UpdateServiceByIdAcceptEnum;
    traceparent?: string;
}

export interface UpsertServiceACLAuthorizationByIdRequest {
    serviceId: string;
    contentType: UpsertServiceACLAuthorizationByIdContentTypeEnum;
    xBOLMemberIdentifier: string;
    aclRevision?: string;
    accept?: UpsertServiceACLAuthorizationByIdAcceptEnum;
    traceparent?: string;
    aCLAuthorizationRequest?: ACLAuthorizationRequest;
}

/**
 * 
 */
export class LogisticsObjectsServicesApi extends runtime.BaseAPI {

    /**
     * ## Description  This endpoint allows the creation of a change request on a specific Service resource, identified by its `ServiceId`.  The change request uses the JSON Patch format as specified in [RFC 6902](https://datatracker.ietf.org/doc/html/rfc6902), enabling clients to submit a set of operations to modify the Service resource.  Client uers must have the provided `requestorMemberIdentifier` as part of their own member identifiers.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Update`. - **ACL Mode**: `WRITE` mode or above is required to create a change request on a Service resource.   - **Note**: The `WRITE` mode is sufficient for creating change requests, but higher modes like `CONTROL` or `Admin` can also be used.   - With `CONTROL` mode, the change request will be automatically accepted and applied, updating the Service resource.   - With `WRITE` mode, the change request will be created but not applied automatically. The change request must then be accepted or rejected using the `PATCH` method on the change request resource. 
     * Create a change request on a Service
     */
    async createChangeRequestOnServiceByIdRaw(requestParameters: CreateChangeRequestOnServiceByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ChangeRequest>> {
        if (requestParameters['serviceId'] == null) {
            throw new runtime.RequiredError(
                'serviceId',
                'Required parameter "serviceId" was null or undefined when calling createChangeRequestOnServiceById().'
            );
        }

        if (requestParameters['contentType'] == null) {
            throw new runtime.RequiredError(
                'contentType',
                'Required parameter "contentType" was null or undefined when calling createChangeRequestOnServiceById().'
            );
        }

        if (requestParameters['changeRequestCreateRequest'] == null) {
            throw new runtime.RequiredError(
                'changeRequestCreateRequest',
                'Required parameter "changeRequestCreateRequest" was null or undefined when calling createChangeRequestOnServiceById().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['source'] != null) {
            queryParameters['source'] = requestParameters['source'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['contentType'] != null) {
            headerParameters['Content-Type'] = String(requestParameters['contentType']);
        }

        if (requestParameters['accept'] != null) {
            headerParameters['Accept'] = String(requestParameters['accept']);
        }

        if (requestParameters['traceparent'] != null) {
            headerParameters['traceparent'] = String(requestParameters['traceparent']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oAuth2Azure", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Ocp-Apim-Subscription-Key"] = await this.configuration.apiKey("Ocp-Apim-Subscription-Key"); // APIKey authentication
        }


        let urlPath = `/services/{serviceId}/change-requests`;
        urlPath = urlPath.replace(`{${"serviceId"}}`, encodeURIComponent(String(requestParameters['serviceId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ChangeRequestCreateRequestToJSON(requestParameters['changeRequestCreateRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ChangeRequestFromJSON(jsonValue));
    }

    /**
     * ## Description  This endpoint allows the creation of a change request on a specific Service resource, identified by its `ServiceId`.  The change request uses the JSON Patch format as specified in [RFC 6902](https://datatracker.ietf.org/doc/html/rfc6902), enabling clients to submit a set of operations to modify the Service resource.  Client uers must have the provided `requestorMemberIdentifier` as part of their own member identifiers.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Update`. - **ACL Mode**: `WRITE` mode or above is required to create a change request on a Service resource.   - **Note**: The `WRITE` mode is sufficient for creating change requests, but higher modes like `CONTROL` or `Admin` can also be used.   - With `CONTROL` mode, the change request will be automatically accepted and applied, updating the Service resource.   - With `WRITE` mode, the change request will be created but not applied automatically. The change request must then be accepted or rejected using the `PATCH` method on the change request resource. 
     * Create a change request on a Service
     */
    async createChangeRequestOnServiceById(requestParameters: CreateChangeRequestOnServiceByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ChangeRequest | null | undefined > {
        const response = await this.createChangeRequestOnServiceByIdRaw(requestParameters, initOverrides);
        switch (response.raw.status) {
            case 201:
                return null;
            case 200:
                return await response.value();
            default:
                return await response.value();
        }
    }

    /**
     * ## Description  This endpoint allows the creation of a new Service.  When creating a Service, the value of the header `X-BOL-Member-Identifier` defines the Service\'s owner. The Member Identifier must be a valid AD Entra ID Object ID of a Member that is part of the authenticated company user.  When creating a Service, its ACL (Access Control List) is initialized with a default set of authorizations. The ACL defines which Members have access to the Service and what actions they can perform.  By default, the ACL is initialized with access for the Member that creates the Service, granting it `CONTROL` access mode. This means that the Member can manage the ACL and perform any operation on the Service.  It is possible to use the header `X-BOL-ACL-authorizations` to specify additional authorizations for the ACL on initialization. The header must contain a JSON array of authorizations to apply in addition to the default one.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Create`. 
     * Create a Service
     */
    async createServiceRaw(requestParameters: CreateServiceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ServiceResponse>> {
        if (requestParameters['contentType'] == null) {
            throw new runtime.RequiredError(
                'contentType',
                'Required parameter "contentType" was null or undefined when calling createService().'
            );
        }

        if (requestParameters['xBOLMemberIdentifier'] == null) {
            throw new runtime.RequiredError(
                'xBOLMemberIdentifier',
                'Required parameter "xBOLMemberIdentifier" was null or undefined when calling createService().'
            );
        }

        if (requestParameters['service'] == null) {
            throw new runtime.RequiredError(
                'service',
                'Required parameter "service" was null or undefined when calling createService().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['id'] != null) {
            queryParameters['id'] = requestParameters['id'];
        }

        if (requestParameters['source'] != null) {
            queryParameters['source'] = requestParameters['source'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['contentType'] != null) {
            headerParameters['Content-Type'] = String(requestParameters['contentType']);
        }

        if (requestParameters['accept'] != null) {
            headerParameters['Accept'] = String(requestParameters['accept']);
        }

        if (requestParameters['traceparent'] != null) {
            headerParameters['traceparent'] = String(requestParameters['traceparent']);
        }

        if (requestParameters['xBOLMemberIdentifier'] != null) {
            headerParameters['X-BOL-Member-Identifier'] = String(requestParameters['xBOLMemberIdentifier']);
        }

        if (requestParameters['xBOLACLAuthorizations'] != null) {
            headerParameters['X-BOL-ACL-authorizations'] = String(requestParameters['xBOLACLAuthorizations']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oAuth2Azure", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Ocp-Apim-Subscription-Key"] = await this.configuration.apiKey("Ocp-Apim-Subscription-Key"); // APIKey authentication
        }


        let urlPath = `/services`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ServiceToJSON(requestParameters['service']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ServiceResponseFromJSON(jsonValue));
    }

    /**
     * ## Description  This endpoint allows the creation of a new Service.  When creating a Service, the value of the header `X-BOL-Member-Identifier` defines the Service\'s owner. The Member Identifier must be a valid AD Entra ID Object ID of a Member that is part of the authenticated company user.  When creating a Service, its ACL (Access Control List) is initialized with a default set of authorizations. The ACL defines which Members have access to the Service and what actions they can perform.  By default, the ACL is initialized with access for the Member that creates the Service, granting it `CONTROL` access mode. This means that the Member can manage the ACL and perform any operation on the Service.  It is possible to use the header `X-BOL-ACL-authorizations` to specify additional authorizations for the ACL on initialization. The header must contain a JSON array of authorizations to apply in addition to the default one.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Create`. 
     * Create a Service
     */
    async createService(requestParameters: CreateServiceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ServiceResponse | null | undefined > {
        const response = await this.createServiceRaw(requestParameters, initOverrides);
        switch (response.raw.status) {
            case 201:
                return null;
            case 200:
                return await response.value();
            default:
                return await response.value();
        }
    }

    /**
     * ## Description  Create an Event of a Service by `serviceId`.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Update`. - **ACL Mode**: `WRITE` mode is required to create an event on a Service resource. 
     * Create an Event of a Service
     */
    async createServiceEventRaw(requestParameters: CreateServiceEventRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['serviceId'] == null) {
            throw new runtime.RequiredError(
                'serviceId',
                'Required parameter "serviceId" was null or undefined when calling createServiceEvent().'
            );
        }

        if (requestParameters['contentType'] == null) {
            throw new runtime.RequiredError(
                'contentType',
                'Required parameter "contentType" was null or undefined when calling createServiceEvent().'
            );
        }

        if (requestParameters['xBOLMemberIdentifier'] == null) {
            throw new runtime.RequiredError(
                'xBOLMemberIdentifier',
                'Required parameter "xBOLMemberIdentifier" was null or undefined when calling createServiceEvent().'
            );
        }

        if (requestParameters['eventCreateRequest'] == null) {
            throw new runtime.RequiredError(
                'eventCreateRequest',
                'Required parameter "eventCreateRequest" was null or undefined when calling createServiceEvent().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['accept'] != null) {
            headerParameters['Accept'] = String(requestParameters['accept']);
        }

        if (requestParameters['contentType'] != null) {
            headerParameters['Content-Type'] = String(requestParameters['contentType']);
        }

        if (requestParameters['traceparent'] != null) {
            headerParameters['traceparent'] = String(requestParameters['traceparent']);
        }

        if (requestParameters['xBOLMemberIdentifier'] != null) {
            headerParameters['X-BOL-Member-Identifier'] = String(requestParameters['xBOLMemberIdentifier']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oAuth2Azure", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Ocp-Apim-Subscription-Key"] = await this.configuration.apiKey("Ocp-Apim-Subscription-Key"); // APIKey authentication
        }


        let urlPath = `/services/{serviceId}/events`;
        urlPath = urlPath.replace(`{${"serviceId"}}`, encodeURIComponent(String(requestParameters['serviceId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: EventCreateRequestToJSON(requestParameters['eventCreateRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * ## Description  Create an Event of a Service by `serviceId`.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Update`. - **ACL Mode**: `WRITE` mode is required to create an event on a Service resource. 
     * Create an Event of a Service
     */
    async createServiceEvent(requestParameters: CreateServiceEventRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.createServiceEventRaw(requestParameters, initOverrides);
    }

    /**
     * ## Description  This endpoint allows the deletion of a specific authorization from the Access Control List (ACL) of a Service resource for a given member, identified by the `memberId`. This removes the access granted to the specified member for the Logistics Object.  - When an ACL authorization is deleted, the member will lose access to the Service resource according to the authorization that was removed. - This operation should be performed with caution as it affects access control to the resource. - The requesting user must have sufficient privileges to modify the ACL.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Update`. - **ACL Mode**: `CONTROL` mode is required to delete authorizations from the ACL of a Service resource. 
     * Delete an authorization of an access control list of a Service by memberId
     */
    async deleteServiceACLAuthorizationByMemberIdRaw(requestParameters: DeleteServiceACLAuthorizationByMemberIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['serviceId'] == null) {
            throw new runtime.RequiredError(
                'serviceId',
                'Required parameter "serviceId" was null or undefined when calling deleteServiceACLAuthorizationByMemberId().'
            );
        }

        if (requestParameters['memberId'] == null) {
            throw new runtime.RequiredError(
                'memberId',
                'Required parameter "memberId" was null or undefined when calling deleteServiceACLAuthorizationByMemberId().'
            );
        }

        if (requestParameters['xBOLMemberIdentifier'] == null) {
            throw new runtime.RequiredError(
                'xBOLMemberIdentifier',
                'Required parameter "xBOLMemberIdentifier" was null or undefined when calling deleteServiceACLAuthorizationByMemberId().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['aclRevision'] != null) {
            queryParameters['aclRevision'] = requestParameters['aclRevision'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['traceparent'] != null) {
            headerParameters['traceparent'] = String(requestParameters['traceparent']);
        }

        if (requestParameters['xBOLMemberIdentifier'] != null) {
            headerParameters['X-BOL-Member-Identifier'] = String(requestParameters['xBOLMemberIdentifier']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oAuth2Azure", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Ocp-Apim-Subscription-Key"] = await this.configuration.apiKey("Ocp-Apim-Subscription-Key"); // APIKey authentication
        }


        let urlPath = `/services/{serviceId}/acl/authorizations/{memberId}`;
        urlPath = urlPath.replace(`{${"serviceId"}}`, encodeURIComponent(String(requestParameters['serviceId'])));
        urlPath = urlPath.replace(`{${"memberId"}}`, encodeURIComponent(String(requestParameters['memberId'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * ## Description  This endpoint allows the deletion of a specific authorization from the Access Control List (ACL) of a Service resource for a given member, identified by the `memberId`. This removes the access granted to the specified member for the Logistics Object.  - When an ACL authorization is deleted, the member will lose access to the Service resource according to the authorization that was removed. - This operation should be performed with caution as it affects access control to the resource. - The requesting user must have sufficient privileges to modify the ACL.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Update`. - **ACL Mode**: `CONTROL` mode is required to delete authorizations from the ACL of a Service resource. 
     * Delete an authorization of an access control list of a Service by memberId
     */
    async deleteServiceACLAuthorizationByMemberId(requestParameters: DeleteServiceACLAuthorizationByMemberIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteServiceACLAuthorizationByMemberIdRaw(requestParameters, initOverrides);
    }

    /**
     * ## Description  This endpoint allows the deletion of a specific Service resource, identified by its `ServiceId`.  - When a Service is deleted, it is permanently removed from the system and cannot be recovered. This operation should be performed with caution. - Deletion of a Service resource is allowed even if the resource is referenced by any other resources or if the references are also deleted. - Deleting a Service resource also deletes any associated change requests and metadata, including the ACL and authorizations, as well as all Logistics Object Events.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Delete`. - **ACL Mode**: `CONTROL` mode is required to delete a Service resource. 
     * Delete a Service by serviceId
     */
    async deleteServiceByIdRaw(requestParameters: DeleteServiceByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['serviceId'] == null) {
            throw new runtime.RequiredError(
                'serviceId',
                'Required parameter "serviceId" was null or undefined when calling deleteServiceById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['traceparent'] != null) {
            headerParameters['traceparent'] = String(requestParameters['traceparent']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oAuth2Azure", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Ocp-Apim-Subscription-Key"] = await this.configuration.apiKey("Ocp-Apim-Subscription-Key"); // APIKey authentication
        }


        let urlPath = `/services/{serviceId}`;
        urlPath = urlPath.replace(`{${"serviceId"}}`, encodeURIComponent(String(requestParameters['serviceId'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * ## Description  This endpoint allows the deletion of a specific Service resource, identified by its `ServiceId`.  - When a Service is deleted, it is permanently removed from the system and cannot be recovered. This operation should be performed with caution. - Deletion of a Service resource is allowed even if the resource is referenced by any other resources or if the references are also deleted. - Deleting a Service resource also deletes any associated change requests and metadata, including the ACL and authorizations, as well as all Logistics Object Events.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Delete`. - **ACL Mode**: `CONTROL` mode is required to delete a Service resource. 
     * Delete a Service by serviceId
     */
    async deleteServiceById(requestParameters: DeleteServiceByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteServiceByIdRaw(requestParameters, initOverrides);
    }

    /**
     * ## Description  This endpoint allows the deletion of a specific event of a Service resource by its `eventId`.  ## Access Control  - **AD Entra ID Role**: Requires the custom role \'BOL.LOGISTICS-OBJECTS.Update\'. - **ACL Mode**: `CONTROL` mode is required to delete an event of a Service resource. 
     * Delete an event of a Service by id
     */
    async deleteServiceEventByIdRaw(requestParameters: DeleteServiceEventByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['serviceId'] == null) {
            throw new runtime.RequiredError(
                'serviceId',
                'Required parameter "serviceId" was null or undefined when calling deleteServiceEventById().'
            );
        }

        if (requestParameters['eventId'] == null) {
            throw new runtime.RequiredError(
                'eventId',
                'Required parameter "eventId" was null or undefined when calling deleteServiceEventById().'
            );
        }

        if (requestParameters['xBOLMemberIdentifier'] == null) {
            throw new runtime.RequiredError(
                'xBOLMemberIdentifier',
                'Required parameter "xBOLMemberIdentifier" was null or undefined when calling deleteServiceEventById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['traceparent'] != null) {
            headerParameters['traceparent'] = String(requestParameters['traceparent']);
        }

        if (requestParameters['xBOLMemberIdentifier'] != null) {
            headerParameters['X-BOL-Member-Identifier'] = String(requestParameters['xBOLMemberIdentifier']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oAuth2Azure", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Ocp-Apim-Subscription-Key"] = await this.configuration.apiKey("Ocp-Apim-Subscription-Key"); // APIKey authentication
        }


        let urlPath = `/services/{serviceId}/events/{eventId}`;
        urlPath = urlPath.replace(`{${"serviceId"}}`, encodeURIComponent(String(requestParameters['serviceId'])));
        urlPath = urlPath.replace(`{${"eventId"}}`, encodeURIComponent(String(requestParameters['eventId'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * ## Description  This endpoint allows the deletion of a specific event of a Service resource by its `eventId`.  ## Access Control  - **AD Entra ID Role**: Requires the custom role \'BOL.LOGISTICS-OBJECTS.Update\'. - **ACL Mode**: `CONTROL` mode is required to delete an event of a Service resource. 
     * Delete an event of a Service by id
     */
    async deleteServiceEventById(requestParameters: DeleteServiceEventByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteServiceEventByIdRaw(requestParameters, initOverrides);
    }

    /**
     * ## Description  Retrieves a specific ChangeRequest associated with a given Service, identified by its `changeRequestId`. This endpoint allows clients to access the details and status of a particular change request, including the set of modifications proposed or applied to the Service resource.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Read`. - **ACL Mode**: `READ` mode is required to access the details of a ChangeRequest resource. 
     * Get a change request on a Service by changeRequestId
     */
    async getChangeRequestOnServiceByIdRaw(requestParameters: GetChangeRequestOnServiceByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ChangeRequest>> {
        if (requestParameters['serviceId'] == null) {
            throw new runtime.RequiredError(
                'serviceId',
                'Required parameter "serviceId" was null or undefined when calling getChangeRequestOnServiceById().'
            );
        }

        if (requestParameters['changeRequestId'] == null) {
            throw new runtime.RequiredError(
                'changeRequestId',
                'Required parameter "changeRequestId" was null or undefined when calling getChangeRequestOnServiceById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['accept'] != null) {
            headerParameters['Accept'] = String(requestParameters['accept']);
        }

        if (requestParameters['traceparent'] != null) {
            headerParameters['traceparent'] = String(requestParameters['traceparent']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oAuth2Azure", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Ocp-Apim-Subscription-Key"] = await this.configuration.apiKey("Ocp-Apim-Subscription-Key"); // APIKey authentication
        }


        let urlPath = `/services/{serviceId}/change-requests/{changeRequestId}`;
        urlPath = urlPath.replace(`{${"serviceId"}}`, encodeURIComponent(String(requestParameters['serviceId'])));
        urlPath = urlPath.replace(`{${"changeRequestId"}}`, encodeURIComponent(String(requestParameters['changeRequestId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ChangeRequestFromJSON(jsonValue));
    }

    /**
     * ## Description  Retrieves a specific ChangeRequest associated with a given Service, identified by its `changeRequestId`. This endpoint allows clients to access the details and status of a particular change request, including the set of modifications proposed or applied to the Service resource.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Read`. - **ACL Mode**: `READ` mode is required to access the details of a ChangeRequest resource. 
     * Get a change request on a Service by changeRequestId
     */
    async getChangeRequestOnServiceById(requestParameters: GetChangeRequestOnServiceByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ChangeRequest> {
        const response = await this.getChangeRequestOnServiceByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ## Description  This endpoint retrieves a specific authorization from the Access Control List (ACL) of a Service resource for a given member, identified by the `memberId`. This allows clients to check the specific access mode granted to a particular member for the Logistics Object.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Read`. - **ACL Mode**: `READ` mode is required to access the ACL authorization of a Service resource. - **Note**: Only the `CONTROL` mode allows to get any member authorization. In `READ`, `WRITE` modes, only the authorization for the authenticated member user can be retrieved. 
     * Get an authorization of an access control list of a Service by memberId
     */
    async getServiceACLAuthorizationByMemberIdRaw(requestParameters: GetServiceACLAuthorizationByMemberIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ACLAuthorization>> {
        if (requestParameters['serviceId'] == null) {
            throw new runtime.RequiredError(
                'serviceId',
                'Required parameter "serviceId" was null or undefined when calling getServiceACLAuthorizationByMemberId().'
            );
        }

        if (requestParameters['memberId'] == null) {
            throw new runtime.RequiredError(
                'memberId',
                'Required parameter "memberId" was null or undefined when calling getServiceACLAuthorizationByMemberId().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['at'] != null) {
            queryParameters['at'] = requestParameters['at'];
        }

        if (requestParameters['aclRevision'] != null) {
            queryParameters['aclRevision'] = requestParameters['aclRevision'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['accept'] != null) {
            headerParameters['Accept'] = String(requestParameters['accept']);
        }

        if (requestParameters['traceparent'] != null) {
            headerParameters['traceparent'] = String(requestParameters['traceparent']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oAuth2Azure", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Ocp-Apim-Subscription-Key"] = await this.configuration.apiKey("Ocp-Apim-Subscription-Key"); // APIKey authentication
        }


        let urlPath = `/services/{serviceId}/acl/authorizations/{memberId}`;
        urlPath = urlPath.replace(`{${"serviceId"}}`, encodeURIComponent(String(requestParameters['serviceId'])));
        urlPath = urlPath.replace(`{${"memberId"}}`, encodeURIComponent(String(requestParameters['memberId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ACLAuthorizationFromJSON(jsonValue));
    }

    /**
     * ## Description  This endpoint retrieves a specific authorization from the Access Control List (ACL) of a Service resource for a given member, identified by the `memberId`. This allows clients to check the specific access mode granted to a particular member for the Logistics Object.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Read`. - **ACL Mode**: `READ` mode is required to access the ACL authorization of a Service resource. - **Note**: Only the `CONTROL` mode allows to get any member authorization. In `READ`, `WRITE` modes, only the authorization for the authenticated member user can be retrieved. 
     * Get an authorization of an access control list of a Service by memberId
     */
    async getServiceACLAuthorizationByMemberId(requestParameters: GetServiceACLAuthorizationByMemberIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ACLAuthorization> {
        const response = await this.getServiceACLAuthorizationByMemberIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ## Description  Retrieves the Access Control List (ACL) for a specific Service resource, identified by its `ServiceId`. The ACL details the authorizations for the authenticated member user.  This endpoint enables clients to review which members have access to the Service and under which access modes, supporting fine-grained authorization.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Read`. - **ACL Mode**: `READ` mode is required to access the ACL of a Service resource. - **Note**: Only the `CONTROL` mode allows to get the Logistics Object ACL with all authorizations. In `READ`, `WRITE`, `READ` mode, the ACL will only contain authorizations for the authenticated member user. 
     * Get ACL of a Service for the authenticated member user. The ACL with the latest revision is returned by default.
     */
    async getServiceACLByIdRaw(requestParameters: GetServiceACLByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ACL>> {
        if (requestParameters['serviceId'] == null) {
            throw new runtime.RequiredError(
                'serviceId',
                'Required parameter "serviceId" was null or undefined when calling getServiceACLById().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['at'] != null) {
            queryParameters['at'] = requestParameters['at'];
        }

        if (requestParameters['revision'] != null) {
            queryParameters['revision'] = requestParameters['revision'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['accept'] != null) {
            headerParameters['Accept'] = String(requestParameters['accept']);
        }

        if (requestParameters['traceparent'] != null) {
            headerParameters['traceparent'] = String(requestParameters['traceparent']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oAuth2Azure", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Ocp-Apim-Subscription-Key"] = await this.configuration.apiKey("Ocp-Apim-Subscription-Key"); // APIKey authentication
        }


        let urlPath = `/services/{serviceId}/acl`;
        urlPath = urlPath.replace(`{${"serviceId"}}`, encodeURIComponent(String(requestParameters['serviceId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ACLFromJSON(jsonValue));
    }

    /**
     * ## Description  Retrieves the Access Control List (ACL) for a specific Service resource, identified by its `ServiceId`. The ACL details the authorizations for the authenticated member user.  This endpoint enables clients to review which members have access to the Service and under which access modes, supporting fine-grained authorization.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Read`. - **ACL Mode**: `READ` mode is required to access the ACL of a Service resource. - **Note**: Only the `CONTROL` mode allows to get the Logistics Object ACL with all authorizations. In `READ`, `WRITE`, `READ` mode, the ACL will only contain authorizations for the authenticated member user. 
     * Get ACL of a Service for the authenticated member user. The ACL with the latest revision is returned by default.
     */
    async getServiceACLById(requestParameters: GetServiceACLByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ACL> {
        const response = await this.getServiceACLByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ## Description  This endpoint retrieves a specific Service by its `ServiceId`.  __Note:__ The `revision` and `at` query parameters cannot be used at the same time. If both are provided simultaneously, the request will result in a `Bad Request` error.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Read`. - **ACL Mode**: `READ` mode is required to access this Service resource. 
     * Get a Service by serviceId
     */
    async getServiceByIdRaw(requestParameters: GetServiceByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ServiceResponse>> {
        if (requestParameters['serviceId'] == null) {
            throw new runtime.RequiredError(
                'serviceId',
                'Required parameter "serviceId" was null or undefined when calling getServiceById().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['at'] != null) {
            queryParameters['at'] = requestParameters['at'];
        }

        if (requestParameters['revision'] != null) {
            queryParameters['revision'] = requestParameters['revision'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['accept'] != null) {
            headerParameters['Accept'] = String(requestParameters['accept']);
        }

        if (requestParameters['traceparent'] != null) {
            headerParameters['traceparent'] = String(requestParameters['traceparent']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oAuth2Azure", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Ocp-Apim-Subscription-Key"] = await this.configuration.apiKey("Ocp-Apim-Subscription-Key"); // APIKey authentication
        }


        let urlPath = `/services/{serviceId}`;
        urlPath = urlPath.replace(`{${"serviceId"}}`, encodeURIComponent(String(requestParameters['serviceId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ServiceResponseFromJSON(jsonValue));
    }

    /**
     * ## Description  This endpoint retrieves a specific Service by its `ServiceId`.  __Note:__ The `revision` and `at` query parameters cannot be used at the same time. If both are provided simultaneously, the request will result in a `Bad Request` error.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Read`. - **ACL Mode**: `READ` mode is required to access this Service resource. 
     * Get a Service by serviceId
     */
    async getServiceById(requestParameters: GetServiceByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ServiceResponse> {
        const response = await this.getServiceByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ## Description  List Events of a Service by `serviceId`, ordered by their `actualDateTime`, from newest to oldest. Events are returned in a paginated format.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Read`. - **ACL Mode**: `READ` mode is required to access the events of a Service resource. 
     * List Events of a Service
     */
    async getServiceEventsRaw(requestParameters: GetServiceEventsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedEvents>> {
        if (requestParameters['serviceId'] == null) {
            throw new runtime.RequiredError(
                'serviceId',
                'Required parameter "serviceId" was null or undefined when calling getServiceEvents().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        if (requestParameters['startAt'] != null) {
            queryParameters['startAt'] = requestParameters['startAt'];
        }

        if (requestParameters['endAt'] != null) {
            queryParameters['endAt'] = requestParameters['endAt'];
        }

        if (requestParameters['code'] != null) {
            queryParameters['code'] = requestParameters['code'];
        }

        if (requestParameters['type'] != null) {
            queryParameters['type'] = requestParameters['type'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['accept'] != null) {
            headerParameters['Accept'] = String(requestParameters['accept']);
        }

        if (requestParameters['traceparent'] != null) {
            headerParameters['traceparent'] = String(requestParameters['traceparent']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oAuth2Azure", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Ocp-Apim-Subscription-Key"] = await this.configuration.apiKey("Ocp-Apim-Subscription-Key"); // APIKey authentication
        }


        let urlPath = `/services/{serviceId}/events`;
        urlPath = urlPath.replace(`{${"serviceId"}}`, encodeURIComponent(String(requestParameters['serviceId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedEventsFromJSON(jsonValue));
    }

    /**
     * ## Description  List Events of a Service by `serviceId`, ordered by their `actualDateTime`, from newest to oldest. Events are returned in a paginated format.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Read`. - **ACL Mode**: `READ` mode is required to access the events of a Service resource. 
     * List Events of a Service
     */
    async getServiceEvents(requestParameters: GetServiceEventsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedEvents> {
        const response = await this.getServiceEventsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ## Description  This endpoint retrieves the metadata of a specific Service by its `ServiceId`.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Read`. - **ACL Mode**: `READ` mode is required to access this resource. 
     * Get a Service metadata by serviceId
     */
    async getServiceMetadataByIdRaw(requestParameters: GetServiceMetadataByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<LogisticsObjectMetadata>> {
        if (requestParameters['serviceId'] == null) {
            throw new runtime.RequiredError(
                'serviceId',
                'Required parameter "serviceId" was null or undefined when calling getServiceMetadataById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['accept'] != null) {
            headerParameters['Accept'] = String(requestParameters['accept']);
        }

        if (requestParameters['traceparent'] != null) {
            headerParameters['traceparent'] = String(requestParameters['traceparent']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oAuth2Azure", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Ocp-Apim-Subscription-Key"] = await this.configuration.apiKey("Ocp-Apim-Subscription-Key"); // APIKey authentication
        }


        let urlPath = `/services/{serviceId}/metadata`;
        urlPath = urlPath.replace(`{${"serviceId"}}`, encodeURIComponent(String(requestParameters['serviceId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => LogisticsObjectMetadataFromJSON(jsonValue));
    }

    /**
     * ## Description  This endpoint retrieves the metadata of a specific Service by its `ServiceId`.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Read`. - **ACL Mode**: `READ` mode is required to access this resource. 
     * Get a Service metadata by serviceId
     */
    async getServiceMetadataById(requestParameters: GetServiceMetadataByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<LogisticsObjectMetadata> {
        const response = await this.getServiceMetadataByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ## Description  Retrieves a list of all change requests associated with the specified Service, identified by its `ServiceId`. This endpoint allows clients to review the history of change requests (such as updates or modifications) that have been submitted for a given Service resource.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Read`. - **ACL Mode**: `READ` mode is required to access the list of change requests for a Service resource. 
     * Get a list of ChangeRequest for Service
     */
    async listChangeRequestsOfServiceByIdRaw(requestParameters: ListChangeRequestsOfServiceByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedChangeRequests>> {
        if (requestParameters['serviceId'] == null) {
            throw new runtime.RequiredError(
                'serviceId',
                'Required parameter "serviceId" was null or undefined when calling listChangeRequestsOfServiceById().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['accept'] != null) {
            headerParameters['Accept'] = String(requestParameters['accept']);
        }

        if (requestParameters['traceparent'] != null) {
            headerParameters['traceparent'] = String(requestParameters['traceparent']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oAuth2Azure", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Ocp-Apim-Subscription-Key"] = await this.configuration.apiKey("Ocp-Apim-Subscription-Key"); // APIKey authentication
        }


        let urlPath = `/services/{serviceId}/change-requests`;
        urlPath = urlPath.replace(`{${"serviceId"}}`, encodeURIComponent(String(requestParameters['serviceId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedChangeRequestsFromJSON(jsonValue));
    }

    /**
     * ## Description  Retrieves a list of all change requests associated with the specified Service, identified by its `ServiceId`. This endpoint allows clients to review the history of change requests (such as updates or modifications) that have been submitted for a given Service resource.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Read`. - **ACL Mode**: `READ` mode is required to access the list of change requests for a Service resource. 
     * Get a list of ChangeRequest for Service
     */
    async listChangeRequestsOfServiceById(requestParameters: ListChangeRequestsOfServiceByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedChangeRequests> {
        const response = await this.listChangeRequestsOfServiceByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ## Description  This endpoint allows updating an existing Service identified by its `ServiceId` using JSON Merge Patch as specified in [RFC 7396](https://datatracker.ietf.org/doc/html/rfc7396). The patch operation applies partial updates to the resource. The underlying mechanism is the creation of a change-request, which will then be automatically accepted and applied.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Update`. - **ACL Mode**: `CONTROL` mode is required to create a change request on a Service resource. 
     * Partially update a Service by applying a JSON Merge Patch change request
     */
    async patchServiceByIdRaw(requestParameters: PatchServiceByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ServiceResponse>> {
        if (requestParameters['serviceId'] == null) {
            throw new runtime.RequiredError(
                'serviceId',
                'Required parameter "serviceId" was null or undefined when calling patchServiceById().'
            );
        }

        if (requestParameters['contentType'] == null) {
            throw new runtime.RequiredError(
                'contentType',
                'Required parameter "contentType" was null or undefined when calling patchServiceById().'
            );
        }

        if (requestParameters['xBOLMemberIdentifier'] == null) {
            throw new runtime.RequiredError(
                'xBOLMemberIdentifier',
                'Required parameter "xBOLMemberIdentifier" was null or undefined when calling patchServiceById().'
            );
        }

        if (requestParameters['service'] == null) {
            throw new runtime.RequiredError(
                'service',
                'Required parameter "service" was null or undefined when calling patchServiceById().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['revision'] != null) {
            queryParameters['revision'] = requestParameters['revision'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['contentType'] != null) {
            headerParameters['Content-Type'] = String(requestParameters['contentType']);
        }

        if (requestParameters['accept'] != null) {
            headerParameters['Accept'] = String(requestParameters['accept']);
        }

        if (requestParameters['traceparent'] != null) {
            headerParameters['traceparent'] = String(requestParameters['traceparent']);
        }

        if (requestParameters['xBOLMemberIdentifier'] != null) {
            headerParameters['X-BOL-Member-Identifier'] = String(requestParameters['xBOLMemberIdentifier']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oAuth2Azure", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Ocp-Apim-Subscription-Key"] = await this.configuration.apiKey("Ocp-Apim-Subscription-Key"); // APIKey authentication
        }


        let urlPath = `/services/{serviceId}`;
        urlPath = urlPath.replace(`{${"serviceId"}}`, encodeURIComponent(String(requestParameters['serviceId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: ServiceToJSON(requestParameters['service']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ServiceResponseFromJSON(jsonValue));
    }

    /**
     * ## Description  This endpoint allows updating an existing Service identified by its `ServiceId` using JSON Merge Patch as specified in [RFC 7396](https://datatracker.ietf.org/doc/html/rfc7396). The patch operation applies partial updates to the resource. The underlying mechanism is the creation of a change-request, which will then be automatically accepted and applied.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Update`. - **ACL Mode**: `CONTROL` mode is required to create a change request on a Service resource. 
     * Partially update a Service by applying a JSON Merge Patch change request
     */
    async patchServiceById(requestParameters: PatchServiceByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ServiceResponse> {
        const response = await this.patchServiceByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ## Description  Retrieves a paginated list of Service resources matching the specified search and filter criteria. This endpoint enables clients to perform advanced queries on Services.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Read`. - **ACL Mode**: `READ` mode is required to access the list of Service resources. 
     * Search for Services
     */
    async searchServiceGetRaw(requestParameters: SearchServiceGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SearchServicesResponse>> {
        const queryParameters: any = {};

        if (requestParameters['id'] != null) {
            queryParameters['id'] = requestParameters['id'];
        }

        if (requestParameters['searchBody'] != null) {
            queryParameters['searchBody'] = requestParameters['searchBody'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['accept'] != null) {
            headerParameters['Accept'] = String(requestParameters['accept']);
        }

        if (requestParameters['traceparent'] != null) {
            headerParameters['traceparent'] = String(requestParameters['traceparent']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oAuth2Azure", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Ocp-Apim-Subscription-Key"] = await this.configuration.apiKey("Ocp-Apim-Subscription-Key"); // APIKey authentication
        }


        let urlPath = `/services/search`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SearchServicesResponseFromJSON(jsonValue));
    }

    /**
     * ## Description  Retrieves a paginated list of Service resources matching the specified search and filter criteria. This endpoint enables clients to perform advanced queries on Services.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Read`. - **ACL Mode**: `READ` mode is required to access the list of Service resources. 
     * Search for Services
     */
    async searchServiceGet(requestParameters: SearchServiceGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SearchServicesResponse> {
        const response = await this.searchServiceGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ## Description  Retrieves a paginated list of Service resources matching the specified search and filter criteria. This endpoint enables clients to perform advanced queries on Services.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Read`. - **ACL Mode**: `READ` mode is required to access the list of Service resources. 
     * Search for Services
     */
    async searchServicesPostRaw(requestParameters: SearchServicesPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SearchServicesResponse>> {
        if (requestParameters['contentType'] == null) {
            throw new runtime.RequiredError(
                'contentType',
                'Required parameter "contentType" was null or undefined when calling searchServicesPost().'
            );
        }

        if (requestParameters['searchServicesRequest'] == null) {
            throw new runtime.RequiredError(
                'searchServicesRequest',
                'Required parameter "searchServicesRequest" was null or undefined when calling searchServicesPost().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['contentType'] != null) {
            headerParameters['Content-Type'] = String(requestParameters['contentType']);
        }

        if (requestParameters['accept'] != null) {
            headerParameters['Accept'] = String(requestParameters['accept']);
        }

        if (requestParameters['traceparent'] != null) {
            headerParameters['traceparent'] = String(requestParameters['traceparent']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oAuth2Azure", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Ocp-Apim-Subscription-Key"] = await this.configuration.apiKey("Ocp-Apim-Subscription-Key"); // APIKey authentication
        }


        let urlPath = `/services/search`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SearchServicesRequestToJSON(requestParameters['searchServicesRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SearchServicesResponseFromJSON(jsonValue));
    }

    /**
     * ## Description  Retrieves a paginated list of Service resources matching the specified search and filter criteria. This endpoint enables clients to perform advanced queries on Services.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Read`. - **ACL Mode**: `READ` mode is required to access the list of Service resources. 
     * Search for Services
     */
    async searchServicesPost(requestParameters: SearchServicesPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SearchServicesResponse> {
        const response = await this.searchServicesPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ## Description  This endpoint allows you to accept or reject a specific ChangeRequest associated with a given Service, using JSON Merge Patch as specified in [RFC 7396](https://datatracker.ietf.org/doc/html/rfc7396). It enables clients to update the status or details of a ChangeRequest, such as marking it as accepted or rejected, and to apply partial modifications to the resource.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Write`. - **ACL Mode**: `CONTROL` mode is required to accept or reject a ChangeRequest on a Service resource. 
     * Accept or reject a ChangeRequest on a  Service using JSON Merge Patch as specified in [RFC 7396](https://datatracker.ietf.org/doc/html/rfc7396).
     */
    async updateChangeRequestOnServiceByIdRaw(requestParameters: UpdateChangeRequestOnServiceByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ChangeRequest>> {
        if (requestParameters['serviceId'] == null) {
            throw new runtime.RequiredError(
                'serviceId',
                'Required parameter "serviceId" was null or undefined when calling updateChangeRequestOnServiceById().'
            );
        }

        if (requestParameters['changeRequestId'] == null) {
            throw new runtime.RequiredError(
                'changeRequestId',
                'Required parameter "changeRequestId" was null or undefined when calling updateChangeRequestOnServiceById().'
            );
        }

        if (requestParameters['contentType'] == null) {
            throw new runtime.RequiredError(
                'contentType',
                'Required parameter "contentType" was null or undefined when calling updateChangeRequestOnServiceById().'
            );
        }

        if (requestParameters['changeRequestPatchRequest'] == null) {
            throw new runtime.RequiredError(
                'changeRequestPatchRequest',
                'Required parameter "changeRequestPatchRequest" was null or undefined when calling updateChangeRequestOnServiceById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['contentType'] != null) {
            headerParameters['Content-Type'] = String(requestParameters['contentType']);
        }

        if (requestParameters['accept'] != null) {
            headerParameters['Accept'] = String(requestParameters['accept']);
        }

        if (requestParameters['traceparent'] != null) {
            headerParameters['traceparent'] = String(requestParameters['traceparent']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oAuth2Azure", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Ocp-Apim-Subscription-Key"] = await this.configuration.apiKey("Ocp-Apim-Subscription-Key"); // APIKey authentication
        }


        let urlPath = `/services/{serviceId}/change-requests/{changeRequestId}`;
        urlPath = urlPath.replace(`{${"serviceId"}}`, encodeURIComponent(String(requestParameters['serviceId'])));
        urlPath = urlPath.replace(`{${"changeRequestId"}}`, encodeURIComponent(String(requestParameters['changeRequestId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: ChangeRequestPatchRequestToJSON(requestParameters['changeRequestPatchRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ChangeRequestFromJSON(jsonValue));
    }

    /**
     * ## Description  This endpoint allows you to accept or reject a specific ChangeRequest associated with a given Service, using JSON Merge Patch as specified in [RFC 7396](https://datatracker.ietf.org/doc/html/rfc7396). It enables clients to update the status or details of a ChangeRequest, such as marking it as accepted or rejected, and to apply partial modifications to the resource.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Write`. - **ACL Mode**: `CONTROL` mode is required to accept or reject a ChangeRequest on a Service resource. 
     * Accept or reject a ChangeRequest on a  Service using JSON Merge Patch as specified in [RFC 7396](https://datatracker.ietf.org/doc/html/rfc7396).
     */
    async updateChangeRequestOnServiceById(requestParameters: UpdateChangeRequestOnServiceByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ChangeRequest> {
        const response = await this.updateChangeRequestOnServiceByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ## Description  This endpoint allows updating an existing Service identified by its `ServiceId`. The underlying mechanism is the creation of a change request, which will then be automatically accepted and applied.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Update`. - **ACL Mode**: `CONTROL` mode is required to create a change request on a Service resource. 
     * Update an existing Service by creating and applying a change request
     */
    async updateServiceByIdRaw(requestParameters: UpdateServiceByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ServiceResponse>> {
        if (requestParameters['serviceId'] == null) {
            throw new runtime.RequiredError(
                'serviceId',
                'Required parameter "serviceId" was null or undefined when calling updateServiceById().'
            );
        }

        if (requestParameters['contentType'] == null) {
            throw new runtime.RequiredError(
                'contentType',
                'Required parameter "contentType" was null or undefined when calling updateServiceById().'
            );
        }

        if (requestParameters['xBOLMemberIdentifier'] == null) {
            throw new runtime.RequiredError(
                'xBOLMemberIdentifier',
                'Required parameter "xBOLMemberIdentifier" was null or undefined when calling updateServiceById().'
            );
        }

        if (requestParameters['service'] == null) {
            throw new runtime.RequiredError(
                'service',
                'Required parameter "service" was null or undefined when calling updateServiceById().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['revision'] != null) {
            queryParameters['revision'] = requestParameters['revision'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['contentType'] != null) {
            headerParameters['Content-Type'] = String(requestParameters['contentType']);
        }

        if (requestParameters['accept'] != null) {
            headerParameters['Accept'] = String(requestParameters['accept']);
        }

        if (requestParameters['traceparent'] != null) {
            headerParameters['traceparent'] = String(requestParameters['traceparent']);
        }

        if (requestParameters['xBOLMemberIdentifier'] != null) {
            headerParameters['X-BOL-Member-Identifier'] = String(requestParameters['xBOLMemberIdentifier']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oAuth2Azure", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Ocp-Apim-Subscription-Key"] = await this.configuration.apiKey("Ocp-Apim-Subscription-Key"); // APIKey authentication
        }


        let urlPath = `/services/{serviceId}`;
        urlPath = urlPath.replace(`{${"serviceId"}}`, encodeURIComponent(String(requestParameters['serviceId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: ServiceToJSON(requestParameters['service']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ServiceResponseFromJSON(jsonValue));
    }

    /**
     * ## Description  This endpoint allows updating an existing Service identified by its `ServiceId`. The underlying mechanism is the creation of a change request, which will then be automatically accepted and applied.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Update`. - **ACL Mode**: `CONTROL` mode is required to create a change request on a Service resource. 
     * Update an existing Service by creating and applying a change request
     */
    async updateServiceById(requestParameters: UpdateServiceByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ServiceResponse> {
        const response = await this.updateServiceByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ## Description  This endpoint allows clients to create or update an authorization in the Access Control List (ACL) of a specific Service resource, identified by its `ServiceId`.  If an authorization already exists for the given `memberIdentifier`, then this authorization is replaced by this requested new authorization.  The value of the header `X-BOL-Member-Identifier` defines the member that authorized the access. The Member Identifier must be a valid AD Entra ID Object ID of a Member that is part of the authenticated company user.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Update`. - **ACL Mode**: `CONTROL` mode is required to add or update authorizations in the ACL of a Service resource. 
     * Upsert (create or update) an authorization of an access control list of a Service.
     */
    async upsertServiceACLAuthorizationByIdRaw(requestParameters: UpsertServiceACLAuthorizationByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ACLAuthorization>> {
        if (requestParameters['serviceId'] == null) {
            throw new runtime.RequiredError(
                'serviceId',
                'Required parameter "serviceId" was null or undefined when calling upsertServiceACLAuthorizationById().'
            );
        }

        if (requestParameters['contentType'] == null) {
            throw new runtime.RequiredError(
                'contentType',
                'Required parameter "contentType" was null or undefined when calling upsertServiceACLAuthorizationById().'
            );
        }

        if (requestParameters['xBOLMemberIdentifier'] == null) {
            throw new runtime.RequiredError(
                'xBOLMemberIdentifier',
                'Required parameter "xBOLMemberIdentifier" was null or undefined when calling upsertServiceACLAuthorizationById().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['aclRevision'] != null) {
            queryParameters['aclRevision'] = requestParameters['aclRevision'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['contentType'] != null) {
            headerParameters['Content-Type'] = String(requestParameters['contentType']);
        }

        if (requestParameters['accept'] != null) {
            headerParameters['Accept'] = String(requestParameters['accept']);
        }

        if (requestParameters['traceparent'] != null) {
            headerParameters['traceparent'] = String(requestParameters['traceparent']);
        }

        if (requestParameters['xBOLMemberIdentifier'] != null) {
            headerParameters['X-BOL-Member-Identifier'] = String(requestParameters['xBOLMemberIdentifier']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oAuth2Azure", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Ocp-Apim-Subscription-Key"] = await this.configuration.apiKey("Ocp-Apim-Subscription-Key"); // APIKey authentication
        }


        let urlPath = `/services/{serviceId}/acl/authorizations`;
        urlPath = urlPath.replace(`{${"serviceId"}}`, encodeURIComponent(String(requestParameters['serviceId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ACLAuthorizationRequestToJSON(requestParameters['aCLAuthorizationRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ACLAuthorizationFromJSON(jsonValue));
    }

    /**
     * ## Description  This endpoint allows clients to create or update an authorization in the Access Control List (ACL) of a specific Service resource, identified by its `ServiceId`.  If an authorization already exists for the given `memberIdentifier`, then this authorization is replaced by this requested new authorization.  The value of the header `X-BOL-Member-Identifier` defines the member that authorized the access. The Member Identifier must be a valid AD Entra ID Object ID of a Member that is part of the authenticated company user.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Update`. - **ACL Mode**: `CONTROL` mode is required to add or update authorizations in the ACL of a Service resource. 
     * Upsert (create or update) an authorization of an access control list of a Service.
     */
    async upsertServiceACLAuthorizationById(requestParameters: UpsertServiceACLAuthorizationByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ACLAuthorization> {
        const response = await this.upsertServiceACLAuthorizationByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

}

/**
 * @export
 */
export const CreateChangeRequestOnServiceByIdContentTypeEnum = {
    ApplicationJson: 'application/json'
} as const;
export type CreateChangeRequestOnServiceByIdContentTypeEnum = typeof CreateChangeRequestOnServiceByIdContentTypeEnum[keyof typeof CreateChangeRequestOnServiceByIdContentTypeEnum];
/**
 * @export
 */
export const CreateChangeRequestOnServiceByIdAcceptEnum = {
    ApplicationJson: 'application/json'
} as const;
export type CreateChangeRequestOnServiceByIdAcceptEnum = typeof CreateChangeRequestOnServiceByIdAcceptEnum[keyof typeof CreateChangeRequestOnServiceByIdAcceptEnum];
/**
 * @export
 */
export const CreateServiceContentTypeEnum = {
    ApplicationJson: 'application/json'
} as const;
export type CreateServiceContentTypeEnum = typeof CreateServiceContentTypeEnum[keyof typeof CreateServiceContentTypeEnum];
/**
 * @export
 */
export const CreateServiceAcceptEnum = {
    ApplicationJson: 'application/json'
} as const;
export type CreateServiceAcceptEnum = typeof CreateServiceAcceptEnum[keyof typeof CreateServiceAcceptEnum];
/**
 * @export
 */
export const CreateServiceEventContentTypeEnum = {
    ApplicationJson: 'application/json'
} as const;
export type CreateServiceEventContentTypeEnum = typeof CreateServiceEventContentTypeEnum[keyof typeof CreateServiceEventContentTypeEnum];
/**
 * @export
 */
export const CreateServiceEventAcceptEnum = {
    ApplicationJson: 'application/json'
} as const;
export type CreateServiceEventAcceptEnum = typeof CreateServiceEventAcceptEnum[keyof typeof CreateServiceEventAcceptEnum];
/**
 * @export
 */
export const GetChangeRequestOnServiceByIdAcceptEnum = {
    ApplicationJson: 'application/json'
} as const;
export type GetChangeRequestOnServiceByIdAcceptEnum = typeof GetChangeRequestOnServiceByIdAcceptEnum[keyof typeof GetChangeRequestOnServiceByIdAcceptEnum];
/**
 * @export
 */
export const GetServiceACLAuthorizationByMemberIdAcceptEnum = {
    ApplicationJson: 'application/json'
} as const;
export type GetServiceACLAuthorizationByMemberIdAcceptEnum = typeof GetServiceACLAuthorizationByMemberIdAcceptEnum[keyof typeof GetServiceACLAuthorizationByMemberIdAcceptEnum];
/**
 * @export
 */
export const GetServiceACLByIdAcceptEnum = {
    ApplicationJson: 'application/json'
} as const;
export type GetServiceACLByIdAcceptEnum = typeof GetServiceACLByIdAcceptEnum[keyof typeof GetServiceACLByIdAcceptEnum];
/**
 * @export
 */
export const GetServiceByIdAcceptEnum = {
    ApplicationJson: 'application/json'
} as const;
export type GetServiceByIdAcceptEnum = typeof GetServiceByIdAcceptEnum[keyof typeof GetServiceByIdAcceptEnum];
/**
 * @export
 */
export const GetServiceEventsAcceptEnum = {
    ApplicationJson: 'application/json'
} as const;
export type GetServiceEventsAcceptEnum = typeof GetServiceEventsAcceptEnum[keyof typeof GetServiceEventsAcceptEnum];
/**
 * @export
 */
export const GetServiceMetadataByIdAcceptEnum = {
    ApplicationJson: 'application/json'
} as const;
export type GetServiceMetadataByIdAcceptEnum = typeof GetServiceMetadataByIdAcceptEnum[keyof typeof GetServiceMetadataByIdAcceptEnum];
/**
 * @export
 */
export const ListChangeRequestsOfServiceByIdAcceptEnum = {
    ApplicationJson: 'application/json'
} as const;
export type ListChangeRequestsOfServiceByIdAcceptEnum = typeof ListChangeRequestsOfServiceByIdAcceptEnum[keyof typeof ListChangeRequestsOfServiceByIdAcceptEnum];
/**
 * @export
 */
export const PatchServiceByIdContentTypeEnum = {
    ApplicationJson: 'application/json'
} as const;
export type PatchServiceByIdContentTypeEnum = typeof PatchServiceByIdContentTypeEnum[keyof typeof PatchServiceByIdContentTypeEnum];
/**
 * @export
 */
export const PatchServiceByIdAcceptEnum = {
    ApplicationJson: 'application/json'
} as const;
export type PatchServiceByIdAcceptEnum = typeof PatchServiceByIdAcceptEnum[keyof typeof PatchServiceByIdAcceptEnum];
/**
 * @export
 */
export const SearchServiceGetAcceptEnum = {
    ApplicationJson: 'application/json'
} as const;
export type SearchServiceGetAcceptEnum = typeof SearchServiceGetAcceptEnum[keyof typeof SearchServiceGetAcceptEnum];
/**
 * @export
 */
export const SearchServicesPostContentTypeEnum = {
    ApplicationJson: 'application/json'
} as const;
export type SearchServicesPostContentTypeEnum = typeof SearchServicesPostContentTypeEnum[keyof typeof SearchServicesPostContentTypeEnum];
/**
 * @export
 */
export const SearchServicesPostAcceptEnum = {
    ApplicationJson: 'application/json'
} as const;
export type SearchServicesPostAcceptEnum = typeof SearchServicesPostAcceptEnum[keyof typeof SearchServicesPostAcceptEnum];
/**
 * @export
 */
export const UpdateChangeRequestOnServiceByIdContentTypeEnum = {
    ApplicationJson: 'application/json'
} as const;
export type UpdateChangeRequestOnServiceByIdContentTypeEnum = typeof UpdateChangeRequestOnServiceByIdContentTypeEnum[keyof typeof UpdateChangeRequestOnServiceByIdContentTypeEnum];
/**
 * @export
 */
export const UpdateChangeRequestOnServiceByIdAcceptEnum = {
    ApplicationJson: 'application/json'
} as const;
export type UpdateChangeRequestOnServiceByIdAcceptEnum = typeof UpdateChangeRequestOnServiceByIdAcceptEnum[keyof typeof UpdateChangeRequestOnServiceByIdAcceptEnum];
/**
 * @export
 */
export const UpdateServiceByIdContentTypeEnum = {
    ApplicationJson: 'application/json'
} as const;
export type UpdateServiceByIdContentTypeEnum = typeof UpdateServiceByIdContentTypeEnum[keyof typeof UpdateServiceByIdContentTypeEnum];
/**
 * @export
 */
export const UpdateServiceByIdAcceptEnum = {
    ApplicationJson: 'application/json'
} as const;
export type UpdateServiceByIdAcceptEnum = typeof UpdateServiceByIdAcceptEnum[keyof typeof UpdateServiceByIdAcceptEnum];
/**
 * @export
 */
export const UpsertServiceACLAuthorizationByIdContentTypeEnum = {
    ApplicationJson: 'application/json'
} as const;
export type UpsertServiceACLAuthorizationByIdContentTypeEnum = typeof UpsertServiceACLAuthorizationByIdContentTypeEnum[keyof typeof UpsertServiceACLAuthorizationByIdContentTypeEnum];
/**
 * @export
 */
export const UpsertServiceACLAuthorizationByIdAcceptEnum = {
    ApplicationJson: 'application/json'
} as const;
export type UpsertServiceACLAuthorizationByIdAcceptEnum = typeof UpsertServiceACLAuthorizationByIdAcceptEnum[keyof typeof UpsertServiceACLAuthorizationByIdAcceptEnum];
